var React = require('react');

function CloseIconX (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Group"),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"Video-Player","transform":"translate(-1117.000000, -136.000000)","stroke":"#000E46","strokeWidth":"2"},React.createElement("g",{"id":"Group","transform":"translate(1118.500000, 136.918058)"},[React.createElement("line",{"x1":"0","y1":"0","x2":"22","y2":"22","id":"Path-2","key":0}),React.createElement("line",{"x1":"0","y1":"0","x2":"22","y2":"22","id":"Path-2","transform":"translate(11.000000, 11.000000) scale(-1, 1) translate(-11.000000, -11.000000) ","key":1})])))]);
}

CloseIconX.defaultProps = {"width":"25px","height":"24px","viewBox":"0 0 25 24","version":"1.1"};

module.exports = CloseIconX;

CloseIconX.default = CloseIconX;
